export default {
    /** 是否显示底部边线 */
    line: false,
    /** 主页按钮显示的文本 */
    homeText: "",
    /** 主页路径 */
    homePath: "",
    /** 自定义返回按钮时跳转的路由地址 */
    backPath: "",
    /** 背景全透明 */
    transparent: false,
    /** z-index层级 */
    zIndex: 990,
    /** 字体和图标颜色 */
    color: "51,51,51",
    /** 自定义position */
    position: "sticky",
    /** 标题框下方是否增加边距 */
    spacing: false,
    /** 文字和图标增加阴影 */
    textShadow: false,
    /** 背景色 */
    background: "255,255,255",
    /** 设备状态栏高度 */
    statusbarHeight: "",
    /** 导航栏可见性 */
    visible: true,
    /** 自定义返回按钮触发的事件 */
    backHandler: void 0,
    /** 占位区域填充 */
    filling: false,
    /** slot区域是否填充模式 */
    slotFull: false
}
